module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-gray-back"
  }, [_c('van-pull-refresh', {
    on: {
      "refresh": _vm.onRefresh
    },
    model: {
      value: (_vm.isLoading),
      callback: function($$v) {
        _vm.isLoading = $$v
      },
      expression: "isLoading"
    }
  }, [_c('van-list', {
    attrs: {
      "finished": _vm.finished,
      "finished-text": "没有更多了"
    },
    on: {
      "load": _vm.onLoad
    },
    model: {
      value: (_vm.loading),
      callback: function($$v) {
        _vm.loading = $$v
      },
      expression: "loading"
    }
  }, _vm._l((_vm.list), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "row-list",
      on: {
        "click": function($event) {
          return _vm.onItemChange(item, index)
        }
      }
    }, [_c('div', {
      staticClass: "sale-box",
      style: (_vm.check_index == index ? 'border:1px solid #ccc' : '')
    }, [_c('div', {
      staticClass: "flex-start goods_item_b"
    }, [_c('img', {
      staticStyle: {
        "width": "1.7rem",
        "height": "1.7rem",
        "min-width": "1.7rem",
        "margin-right": "0.2rem"
      },
      attrs: {
        "src": item.pic_url,
        "alt": "",
        "srcset": ""
      }
    }), _vm._v(" "), _c('div', {
      staticStyle: {
        "height": "1.7rem",
        "flex": "1"
      }
    }, [_c('div', {
      staticClass: "show-two-row"
    }, [_vm._v(_vm._s(item.goods_name))]), _vm._v(" "), _c('div', {
      staticClass: "show-two-row",
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v("\n                " + _vm._s(item.goods_price) + "\n              ")]), _vm._v(" "), _c('div', {
      staticClass: "flex-between"
    }, [(item.sku_id) ? _c('div', {
      staticClass: "show-one-row",
      staticStyle: {
        "width": "4rem"
      }
    }, [_vm._v("\n                  " + _vm._s(item.sku_name) + "\n                ")]) : _c('div', [_vm._v("未选择规格")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "0.8rem",
        "min-width": "0.8rem",
        "text-align": "right"
      }
    }, [_vm._v("\n                  x" + _vm._s(item.goods_count) + "\n                ")])])])])])])
  }), 0)], 1), _vm._v(" "), _c('van-action-sheet', {
    attrs: {
      "actions": _vm.actions
    },
    on: {
      "closed": _vm.onClose,
      "select": _vm.onSelect
    },
    model: {
      value: (_vm.show),
      callback: function($$v) {
        _vm.show = $$v
      },
      expression: "show"
    }
  }), _vm._v(" "), _c('LoginDialog', {
    attrs: {
      "show": _vm.loginShow
    },
    on: {
      "loginSuccess": _vm.loginSuccess,
      "loginCancel": _vm.loginCancel
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "add-btn"
  }, [_c('div', {
    staticClass: "add-b-b"
  }, [_c('van-button', {
    attrs: {
      "round": "",
      "type": "info"
    },
    on: {
      "click": _vm.onSaleGoodsAdd
    }
  }, [_vm._v("新增商品")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b67fead8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/configure/SaleGoodsList.vue
// module id = 2574
// module chunks = 0